module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-3.fce89530.jpg";